import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { LoggedInGuard, ResetAttributesService } from '@ftr/ui-user'
import { PasswordResetParams } from './password-reset.params'
import { ResetSentPage } from './reset-sent.page'
import { ResetPage } from './reset.page'

@NgModule({
  providers: [ResetAttributesService],
  imports: [
    RouterModule.forChild([
      {
        path: 'reset',
        component: ResetPage,
        canActivate: [LoggedInGuard],
        data: {
          title: 'Reset Your Password',
        },
      },
      {
        path: 'reset-sent',
        component: ResetSentPage,
        canActivate: [LoggedInGuard],
        data: {
          title: 'Request Email Sent',
        },
      },
      // Lazy load the verify route page in its own module.
      // Keeps password verification library out of the main bundle.
      {
        path: `resetverify/:${PasswordResetParams.Username}`,
        loadChildren: () => import('./password-reset-verify-page.module').then(m => m.PasswordResetVerifyPageModule),
      },
    ]),
  ],
  exports: [RouterModule],
})
export class PasswordResetPagesModule {}
